<div class="whos-participating">
  <div class="whos-participating-title">
    <div class="whos-participating-title__title">{{ title }}</div>
    <div class="whos-participating-title__subtitle">{{ subtitle }}</div>
  </div>

  <div role="content" class="whos-participating-content">
    @if (!ready) {
      <div>
        <se-fe-spinner
          [seFeDataSize]="900"
          [seFeDataInverted]="false"
          [seFeDataCenter]="true"
        ></se-fe-spinner>
      </div>
    }
    @if (ready) {
      <section class="whos-participating-buttons">
        <button (click)="submitter.myChild()">
          <se-po-highlight-label
            theme="child"
          [label]="childLabel"></se-po-highlight-label>
        </button>
        <button (click)="submitter.myself()">
          <se-po-highlight-label
            theme="adult"
          [label]="meLabel"></se-po-highlight-label>
        </button>
      </section>
    }
  </div>
</div>
